<template>
  <md-dialog
      :class="dialogClass"
      v-model="showDialog"
      title=""
      :closable="false"
      :mask-closable="dialogType === 3"
      @hide="onClose"
  >
<!--    图片-->
    <div class="pic-wrapper" v-if="dialogType === 1">
<!--      <md-swiper-->
<!--          v-if="picAnnouncement.length && value"-->
<!--          ref="swiper"-->
<!--          :is-prevent="false"-->
<!--          :is-loop="false"-->
<!--          :useNative-driver="false"-->
<!--          :has-dots="false"-->
<!--          class="swiper"-->
<!--      >-->
<!--        <md-swiper-item :key="index" v-for="(item, index) in picAnnouncement">-->
<!--          <img :src="item.pic" @click="jumpTo(item)" />-->
<!--        </md-swiper-item>-->
<!--      </md-swiper>-->

      <img :src="picAnnouncement.length && picAnnouncement[picCurrentIndex] && picAnnouncement[picCurrentIndex].pic" @click="jumpTo(picAnnouncement[picCurrentIndex])" />
    </div>

<!--    app应用弹窗-->
    <template v-if="dialogType === 2">
      <div class="app-center-wrapper">
        <div class="inner-wrapper">
          <app-list @onClose="showDialog = false" />
        </div>
      </div>
    </template>

<!--    图文-->
    <template #header v-if="dialogType === 3">
      <div class="header-left header">
        <img src="./assets/icon1.png" alt="" />
      </div>
      <div class="header-right header">
        <img src="./assets/icon2.png" alt="" />
      </div>
    </template>

    <template v-if="dialogType === 3">
      <div class="h-40"></div>
      <div class="title">官方公告</div>

      <div class="rich-content" v-html="richText.length && richText[0].content"></div>

      <div class="app-center" @click="jumpTo({ url: '/apps'  }, true)">应用中心</div>
    </template>

    <img class="close-icon" src="./assets/closeIcon.png" v-show="[1, 2].includes(dialogType)" @click="showDialog = false" />
  </md-dialog>
</template>

<script>
import { Dialog, Swiper, SwiperItem } from 'mand-mobile';
import picDev from './assets/picDev.png';
import appList from './components/appList';

export default {
  name: 'Announcement',
  components: {
    [Dialog.name]: Dialog,
    [Swiper.name]: Swiper,
    [SwiperItem.name]: SwiperItem,
    appList
  },
  props: {
    dialogType: {
      type: Number || String,
      default: 1// 1 图片， 2 应用列表弹框， 3 富文本
    }
  },
  data () {
    return {
      bannerList: [picDev, picDev, picDev],
      picCurrentIndex: 0,
      showDialog: false
    };
  },
  computed: {
    ...mapState('publicStore', [
      'picAnnouncement',
      'richText',
      'isShowAnnouncementPic',
      'isShowAnnouncementApp',
      'isShowAnnouncementRichText',
      'isApp',
      'isWebClip'
    ]),
    ...mapGetters('publicStore', ['isH5']),
    dialogClass () {
      return {
        1: 'pic-dialog',
        2: 'app-center-dialog',
        3: 'rich-text-dialog'
      }[this.dialogType];
    }
  },
  watch: {
    isShowAnnouncementPic (val) {
      if (this.dialogType === 1) {
        this.showDialog = val;
      }
    },
    isShowAnnouncementApp (val) {
      if (this.dialogType === 2) {
        this.showDialog = val;
      }
    },
    isShowAnnouncementRichText (val) {
      if (this.dialogType === 3) {
        this.showDialog = val;
      }
    }
  },
  methods: {
    ...mapMutations('publicStore', [
      'setIsShowAnnouncementPic',
      'setIsShowAnnouncementApp',
      'setIsShowAnnouncementRichText'
    ]),
    jumpTo ({ url }, inner = false) {
      if (url) {
        if (inner) {
          this.$router.push(url);
        } else {
          // window.open(item.url);

          // localStorage.setItem('fromRoute', this.$route.fullPath);
          // localStorage.setItem('thirdPageSrc', url);
          // this.$router.push('/thirdPage');
          if (this.isH5) {
            // h5打开新窗口跳转
            this.jumpPath({ url, isNew: true });
          } else {
            this.jumpPath({ url });
          }
        }

        if (this.dialogType === 1) {
          this.setIsShowAnnouncementPic(false);
        } else {
          this.onClose();
        }

        this.$emit('closeType', 'jump');
      }
    },
    onClose () {
      switch (this.dialogType) {
        case 1:
          this.setIsShowAnnouncementPic(false);

          this.picCurrentIndex++;

          if (this.picCurrentIndex <= this.picAnnouncement.length - 1) {
            this.$emit('canShowAnnouncementPic', true);
          } else {
            this.$emit('canShowAnnouncementPic', false);
          }

          break;
        case 2:
          this.setIsShowAnnouncementApp(false);
          break;
        case 3:
          this.setIsShowAnnouncementRichText(false);
          break;
      }

      this.$emit('closeType', 'closeBtn');
    }
  }
};
</script>

<style scoped lang="scss">
.pic-dialog {
  /deep/ .md-popup {
    z-index: 10000000000000000;
  }

  /deep/ .md-dialog-content {
    width: 350px!important;
    height: 435px;
    border-radius: 8px;
    overflow: hidden;
    background-color: transparent;

    .md-dialog-body {
      padding: 0;

      .pic-wrapper {
        width: 350px!important;
        height: 385px!important;
        overflow: auto;
        border-radius: 8px;

        img {
          width: 100%;
          //height: 100%;
        }
      }

      //.swiper {
      //  width: 350px!important;
      //  height: 385px!important;
      //
      //  .md-swiper-item {
      //    width: 350px!important;
      //    height: 385px!important;
      //    overflow: auto;
      //
      //    img {
      //      width: 100%;
      //      //height: 100%;
      //    }
      //  }
      //}
    }
  }
}

.rich-text-dialog {
  /deep/ .md-popup {
    z-index: 10000000000000000;
  }

  /deep/ .md-dialog-content {
    width: 320px!important;
    border: 1px solid transparent;
    background-clip: padding-box, border-box;
    background-origin: padding-box, border-box;
    background-image: linear-gradient(to right, #161623, #161623),linear-gradient(180deg, #32B8AF 0%, #161623 50%, #6D6D6D 100%);

    .header {
      position: absolute;

      &.header-left {
        left: 0;
        top: -54px;
        img {
          width: 122px;
        }
      }

      &.header-right {
        right: 0;
        top: -30px;
        img {
          width: 95px;
        }
      }
    }

    .md-dialog-body {
      padding: 23px 15px 18px;

      .h-40 {
        height: 15px;
      }
      .title {
        font-family: YouSheBiaoTiHei;
        font-size: 36px;
        font-weight: 400;
        letter-spacing: -0.8px;
        text-align: center;
        color: #FFD75F;
      }

      .rich-content {
        height: 350px;
        overflow: auto;
        margin-bottom: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        letter-spacing: 0;
        color: #FFFFFFCC;
      }

      .app-center {
        width: 270px;
        height: 40px;
        margin: auto;
        border-radius: 6px;
        background: #32B8AF;
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 14px;
        line-height: 40px;
        letter-spacing: 0;
        text-align: center;
        color: #FFFFFF;
      }
    }
  }
}

.app-center-dialog {
  /deep/ .md-popup {
    top: -80px;
    z-index: 10000000000000000;
  }

  /deep/ .md-dialog-content {
    width: 310px !important;
    //height: 414px;
    background-color: transparent;

    .md-dialog-body {
      padding: 0;

      .app-center-wrapper {
        position: relative;
        width: 310px !important;
        height: 414px;
        background: url("./assets/appCenterBg.png") 0 0/100% 100%;

        .inner-wrapper {
          position: absolute;
          top: 125px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          flex-wrap: wrap;
          width: 294px;
          height: 280px;
          padding: 14px;
          overflow: auto;

          .app-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 50px;
            margin-right: 22px;
            margin-bottom: 14px;

            &:nth-of-type(4n) {
              margin-right: 0;
            }

            .app-img {
              width: 50px;
              height: 50px;
              margin-bottom: 4px;
            }

            .app-name {
              font-family: PingFang SC;
              font-weight: 500;
              font-size: 10px;
              line-height: 10px;
              letter-spacing: 0;
              color: #161616;
            }
          }
        }
      }
    }
  }
}

.close-icon {
  position: relative;
  z-index: 100000;
  width: 32px!important;
  height: 32px!important;
  margin: 18px auto 0;
}

/deep/ .md-dialog-actions {
  display: none;
}
</style>
